<div *renderingPermissionDirective="[
    'SysLogReader',
    'SysLogWriter',
    'SysLogAdmin',
  ]" class="request-grid">
  <div class="request-grid__content">
    <dcc-page-title title="Syslogs"></dcc-page-title>

    <div class="tabs" style="margin-bottom: 20px; border-bottom: 1px solid #dee2e6;">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'history'" (click)="setActiveTab('history')"
            style="cursor: pointer;">Request History</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab === 'live'" (click)="setActiveTab('live')"
            style="cursor: pointer;">Live Viewer</a>
        </li>
      </ul>
    </div>

    <ng-container *ngIf="activeTab === 'history'">
      <div class="request-grid__header">
        <dcc-new-request></dcc-new-request>
      </div>
      <div class="request-grid__actions">
        <div class="request-grid__refresh">
          <button class="lx-btn-small lx-btn-text" (click)="onRefresh()">
            <i class="lx-icon lx-reset"></i>
            Refresh
          </button>
        </div>
      </div>
      <div class="request-grid__data">
        <ag-grid-angular class="ag-theme-alpine ag-grid-sticky-header" domLayout="autoHeight"
          style="width: 100%; height: 100%" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
          [enableCellTextSelection]="true" [ensureDomOrder]="true" [suppressRowHoverHighlight]="true"
          (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
      <div class="request-grid__pagination_container">
        <div class="request-grid__pagination_container__count-select">
          <label>Show</label>
          <dcc-dropdown [pageSizes]="pageSizes" [selectedSize]="pageSize"
            (changedPageSize)="onPageSizeSelected($event)"></dcc-dropdown>
          <label>Items</label>
        </div>
        <div class="request-grid__pagination_container__page-select">
          <paginator [currentPageNumber]="currentPage" [endOfSet]="endOfSet" [pageNumbers]="paginationTokenMap.size"
            (selectedPage)="onPageSelection($event)"></paginator>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'live'">
      <div class="live-syslog">
        <dcc-live-syslog></dcc-live-syslog>
      </div>
    </ng-container>
  </div>
</div>
